import React, { useEffect, useState } from "react";

import {
    Text,
    View
} from "react-native";
import AppTheme from "../../../utils/Theme";
import { UserType } from "./Landing";
import { Image } from "react-native";
import Images from "../../../../specific/utils/Images";
import AuthHeaderStyle from "../../../styles/auth/AuthHeaderStyle";

interface AuthHeaderProps {
    type?: UserType,
    showTitle?: boolean
}

const AuthHeader = (props: AuthHeaderProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const authHeaderStyle: AuthHeaderStyle = new AuthHeaderStyle();

    const [titleElements, setTitleElements] = useState<string[]>(["Vous aider", "à faire grandir", "les enfants en confiance"]);
    const [titleColor, setTitleColor] = useState<string>(appTheme.darkBlue);
    const [userTypeIcon, setUserTypeIcon] = useState(images.icLiliCircle);

    const { type = "neutral", showTitle = true } = props;

    const whiteBlockWidth = appTheme.pixelPerfect(100)

    useEffect(() => {
        if (props.type !== undefined) {
            if (props.type === "neutral") {
                setTitleElements(["Vous aider", "à faire grandir", "les enfants en confiance"]);
                setTitleColor(appTheme.darkBlue);
                setUserTypeIcon(images.icLiliCircle);
            } else if (props.type === "family") {
                setTitleElements(["Le 1er programme", "COMPAGNON DES PARENTS", "basé sur les neurosciences"]);
                setTitleColor(appTheme.white);
                setUserTypeIcon(images.icLiliAtHomeCircle);
            } else if (props.type === "animator") {
                setTitleElements(["Apprendre à", "vivre ensemble", "en s'amusant"]);
                setTitleColor(appTheme.darkBlue);
                setUserTypeIcon(images.icLiliAtExtracurricularCircle);
            } else if (props.type === "teacher") {
                setTitleElements(["Améliorer le", "bien-être", "à l'école"]);
                setTitleColor(appTheme.darkBlue);
                setUserTypeIcon(images.icLiliAtSchoolCircle);
            }
        }
    }, [props]);

    const getLeftDetails = () => {
        if (props.type === "teacher") {
            return <View style={[authHeaderStyle.leftDetailsView, { width: whiteBlockWidth }]}>
                <Image source={images.icMinistere} style={{ width: appTheme.pixelPerfect(80), height: appTheme.pixelPerfect(80) }} resizeMode="contain" />
            </View>
        }
        return <View />
    }

    const getRightDetails = () => {
        if (props.type === "teacher") {
            return <View style={[{ width: whiteBlockWidth }]} />
        }
        return <View />
    }

    console.log({type: props.type});

    return (<View style={{ justifyContent: "center", alignItems: "center", marginBottom: appTheme.pixelPerfect(10), marginTop: appTheme.pixelPerfect(10) }}>
        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: appTheme.getFullScreenWidth() }}>
            {getLeftDetails()}
            <View style={{ flex: 1, alignItems: "center" }}>
                <Image source={userTypeIcon} style={{ width: appTheme.pixelPerfect(60), height: appTheme.pixelPerfect(60) }} />
                <View style={authHeaderStyle.titleContainer}>
                    <Text style={[((props.type === "neutral") || (props.type === undefined)) ? authHeaderStyle.superHerostitle : authHeaderStyle.title, { color: titleColor }]}>{titleElements[0]}</Text>
                    <Text style={[authHeaderStyle.superHerostitle, { color: titleColor }]}>{titleElements[1]}</Text>
                    <Text style={[props.type === "neutral" ? authHeaderStyle.superHerostitle : authHeaderStyle.title, { color: titleColor }]}>{titleElements[2]}</Text>
                </View>
            </View>
            {getRightDetails()}
        </View>
    </View>)

}

export default AuthHeader;